"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductSlugsForProjectType = exports.PROJECT_TYPE_TO_PRODUCT_SLUGS = exports.isValidProjectType = exports.ALL_PROJECT_TYPES = exports.MOBILE_PROJECT_TYPES = exports.WEB_PROJECT_TYPES = exports.ProjectType = void 0;
const billing_utils_1 = require("@deque/billing-utils");
/** Valid DevHub project types */
var ProjectType;
(function (ProjectType) {
    /** Refers to Axe Watcher  */
    ProjectType["Watcher"] = "axe-devtools-watcher";
    /** Refers to the Axe DevToolsCLI and Axe DevTools APIs  */
    ProjectType["Html"] = "axe-devtools-html";
    /** Refers to Axe DevTools for Mobile products SDKs and Appium*/
    ProjectType["Mobile"] = "axe-devtools-mobile";
    /** Refers to Axe DevTools for Mobile desktop mobile analyzer */
    ProjectType["MobileAnalyzer"] = "axe-devtools-mobile-analyzer";
})(ProjectType || (exports.ProjectType = ProjectType = {}));
/** Project types that are considered "web" projects */
exports.WEB_PROJECT_TYPES = [
    ProjectType.Watcher,
    ProjectType.Html
];
/** Project types that are considered "mobile" projects */
exports.MOBILE_PROJECT_TYPES = [
    ProjectType.Mobile,
    ProjectType.MobileAnalyzer
];
/** All valid DevHub project types */
exports.ALL_PROJECT_TYPES = [
    ...exports.WEB_PROJECT_TYPES,
    ...exports.MOBILE_PROJECT_TYPES
];
/** Returns true if the given string is a valid DevHub project type */
const isValidProjectType = (value) => exports.ALL_PROJECT_TYPES.includes(value.trim());
exports.isValidProjectType = isValidProjectType;
/**
 * Single source of truth: `ProjectType` → the `ProductSlugs` associated with
 * it.
 *
 * Positional contract (load-bearing — relied on by consumers):
 * - `[0]` is the **API-key slug**: the only slug that can appear on an API
 *   key for projects of this type. Treat it as the canonical
 *   licensing/eligibility identifier when issuing or validating API keys.
 * - `[1..]` are **additional subscription slugs** that also license the
 *   project type (e.g. a web project is licensed by either
 *   `axeDevToolsWatcher` or `axeDevToolsHTML`). Use these for subscription
 *   filtering, not for API-key gating.
 *
 * The two roles intentionally share one array so a single helper can serve
 * both call sites — the API-key code reads `[0]`, the subscription-filter
 * code reads the whole array. The ordering invariant is enforced by tests.
 *
 * Exhaustive over `ProjectType` — adding a new project type fails to compile
 * here until a slug list is provided.
 */
exports.PROJECT_TYPE_TO_PRODUCT_SLUGS = {
    [ProjectType.Watcher]: [
        billing_utils_1.ProductSlugs.axeDevToolsWatcher,
        billing_utils_1.ProductSlugs.axeDevToolsHTML
    ],
    // Web projects' API keys are always issued under the Watcher slug, even
    // for HTML projects — so Watcher leads here despite the enum name.
    [ProjectType.Html]: [
        billing_utils_1.ProductSlugs.axeDevToolsWatcher,
        billing_utils_1.ProductSlugs.axeDevToolsHTML
    ],
    // Mobile project types intentionally have no additional subscription
    // slugs — `axeDevToolsMobile` is the sole slug that both issues the API
    // key and licenses the project. There is no separate MobileAnalyzer
    // product slug in billing-utils.
    [ProjectType.Mobile]: [billing_utils_1.ProductSlugs.axeDevToolsMobile],
    [ProjectType.MobileAnalyzer]: [billing_utils_1.ProductSlugs.axeDevToolsMobile]
};
/**
 * Returns the product slugs associated with a project type, or `null` if
 * the input is not a valid `ProjectType`.
 *
 * The `null` return distinguishes "unknown project type" from a
 * (hypothetical) project type with zero licensing slugs — callers MUST NOT
 * treat a missing value as "no license required."
 *
 * On a valid input, the first element is the API-key slug; any additional
 * elements are extra subscription slugs that license the project type. See
 * `PROJECT_TYPE_TO_PRODUCT_SLUGS` for the full positional contract.
 */
const getProductSlugsForProjectType = (value) => {
    if (!value) {
        return null;
    }
    const trimmed = value.trim();
    if (!(0, exports.isValidProjectType)(trimmed)) {
        return null;
    }
    return exports.PROJECT_TYPE_TO_PRODUCT_SLUGS[trimmed];
};
exports.getProductSlugsForProjectType = getProductSlugsForProjectType;
//# sourceMappingURL=projectTypes.js.map